<template>
  <div class="datepicker-wrapper p1">
    <VueDatepicker v-model="_value" :inline="inline" :monday-first="true" :full-month-name="true" :language="DatepickerLocalizationFi" v-bind="$attrs" calendar-class="calendar" />
  </div>
</template>

<script>

import VueDatepicker from 'vuejs-datepicker';
import { fi as DatepickerLocalizationFi } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'Datepicker',
  components: {
    VueDatepicker,
  },
  inheritAttrs: false,
  props: {
    value: null,
    inline: { type: Boolean, default: true },
  },
  data() {
    return {
      DatepickerLocalizationFi,
    };
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
  },
};

</script>

<style scoped>
  .datepicker-wrapper >>> .calendar {
    background: none;
    border: none;
    width: 100%;
  }

  .datepicker-wrapper >>> header > span {
    text-transform: capitalize;
    font-weight: var(--semibold)
  }

  .datepicker-wrapper >>> .day-header {
    color: var(--gray-3);
    text-transform: uppercase;
  }

  .datepicker-wrapper >>> .calendar .cell {
    position: relative;
    z-index: 0;
    font-weight: var(--semibold);
    background: transparent !important;
    height: 42px !important;
    line-height: 34px !important;
    border: solid transparent !important;
    border-width: 4px 1px !important;
    border-radius: 4px !important;
  }

  .datepicker-wrapper >>> .calendar .cell::before {
    position: absolute;
    z-index: -1;
    background: transparent;
    border-radius: 4px;
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }

  .datepicker-wrapper >>> .cell:not(.blank):not(.disabled)::before {
    background: var(--white);
  }

  .datepicker-wrapper >>> .calendar .cell.disabled {
    color: var(--gray-3);
  }

  .datepicker-wrapper >>> .calendar .cell.disabled::before {
    background: var(--gray-4);
  }

  .datepicker-wrapper >>> .calendar .cell.selected {
    color: var(--white);
  }


  .datepicker-wrapper >>> .calendar .cell.selected::before {
    background: var(--blue);
  }

  .datepicker-wrapper >>> .cell.day:not(.blank):not(.disabled):hover::before {
    border: 3px solid var(--blue);
  }
</style>
